import profile from "./assets/profile.jpeg";

export const personalData = {
  name: "Muaviya Imran",
  designation: ["Full-Stack Software Engineer", "React / Next.js Developer"],
  github: "https://github.com/MuaviyaImran",
  linkedIn: "https://www.linkedin.com/in/muaviya-imran-4749a7215/",
  facebook:
    "https://www.facebook.com/profile.php?id=100013990093022&mibextid=ZbWKwL",
  instagram: "https://www.instagram.com/itxx_muaviya/",
  skills: [
    "JavaScript",
    "TypeScript",
    "React.js",
    "Next.js",
    "Vue.js",
    "Nuxt.js",
    "Tailwind CSS",
    "Go",
    "Node.js",
    "PostgreSQL",
    "Redis",
    "Supabase",
    "REST APIs",
    "Zustand",
    "Redux",
    "Pinia",
    "shadcn/ui",
    "Material UI",
    "Ant Design",
    "Wagmi",
    "Viem",
    "WalletConnect",
    "OpenAI API",
    "Leaflet",
    "Recharts",
    "TradingView",
    "TanStack Query",
    "TanStack Router",
    "Vite",
    "Capacitor",
    "Python",
    "Flutter",
    "Git",
    "Vercel",
    "Railway",
  ],
  email: "muaviyaimran1122@gmail.com",
  phone: "+923249411360",
  address: "Lahore, Pakistan",
};

export const AboutData = {
  name: "Muaviya Imran",
  description:
    "Full-stack software engineer with 2+ years of experience building production web applications, dashboards, and internal business platforms. I work across React.js, Next.js, TypeScript, Tailwind CSS, Go, Node.js, PostgreSQL, REST APIs, and modern state management, with recent projects in CRM, payroll automation, Web3 trading dashboards, geospatial intelligence, AI reporting, and data-driven simulation tools.",
  profile: profile,
};

export const experiences = [
  {
    id: 1,
    title: "Software Engineer",
    company: "Golden Gate Innovations",
    duration: "Dec 2025 - Present",
    location: "Lahore, Pakistan",
    responsibilities: [
      "Built production web applications across Next.js, React, TypeScript, Tailwind CSS, Zustand, and REST APIs for CRM, analytics, geospatial, AI, and Web3 platforms.",
      "Developed a Go and PostgreSQL operations platform with payroll, reimbursements, Supabase JWT authentication, Dropbox uploads, Resend email delivery, and PDF payslip generation.",
      "Implemented interactive dashboards with filtering, pagination, role-aware flows, map-based scenario visualization, formula-driven simulations, reporting, and Excel workflows.",
    ],
  },
  {
    id: 2,
    title: "Software Engineer (Frontend)",
    company: "Datum Brain",
    duration: "Sep 2023 - Dec 2025",
    location: "Lahore, Pakistan",
    responsibilities: [
      "Engineered and optimized scalable web applications using React.js, Vue.js, Next.js, and Tailwind CSS.",
      "Conducted client meetings to gather requirements, provide progress updates, and align delivery with business needs.",
      "Collaborated with cross-functional teams to maintain high-quality delivery standards across multiple products.",
    ],
  },
  {
    id: 3,
    title: "Full Stack Developer Intern",
    company: "Shayan Solutions",
    duration: "Jun 2023 - Sep 2023",
    location: "Lahore, Pakistan",
    responsibilities: [
      "Built an AI-based content generator using Next.js and integrated OpenAI APIs for prompt-driven content creation.",
      "Implemented Stripe and PayPal payment gateway flows.",
      "Worked on both SSR and CSR architectures with responsive frontend implementation.",
    ],
  },
  {
    id: 4,
    title: "Full Stack Developer",
    company: "Freelance",
    duration: "Aug 2021 - Present",
    location: "Lahore, Pakistan",
    responsibilities: [
      "Integrated AI-trained models into web applications using Next.js.",
      "Developed a library management system and other client-facing web applications.",
      "Integrated AI models into Flutter mobile applications.",
    ],
  },
  {
    id: 5,
    title: "Salesforce Back-end Developer Intern",
    company: "Systems Limited",
    duration: "Aug 2021 - Nov 2021",
    location: "Lahore, Pakistan",
    responsibilities: [
      "Explored Salesforce architecture and backend development concepts.",
      "Studied and practiced SFRA architecture flows.",
    ],
  },
];

export const skillsData = [
  "Javascript",
  "Typescript",
  "ReactJs",
  "Next Js",
  "Vue",
  "Nuxt Js",
  "Tailwind",
  "Bootstrap",
  "MaterialUI",
  "NodeJs",
  "goLang",
  "Postgresql",
  "redis",
  "Python",
  "Flask",
  "FastAPI",
  "RestAPI",
  "Flutter",
  "Firebase",
  "ViteJs",
  "Docker",
  "Git",
];

export const projectsData = [
  {
    id: 1,
    name: "GGI Operations Platform",
    description:
      "Internal operations platform for employee management, payroll, reimbursements, departments, users, and salary slip workflows with automated PDFs and email delivery.",
    liveUrl: "",
    role: "Full-Stack Developer",
    stack:
      "Go, PostgreSQL, Next.js, React.js, TypeScript, Tailwind CSS, Supabase, Dropbox API, Resend",
  },
  {
    id: 2,
    name: "Web3 Vault and Trading Dashboard",
    description:
      "Vault, trader, investor, wallet authentication, settlement, profit tracking, and trading dashboard modules with secure wallet connectivity and real-time market views.",
    liveUrl: "",
    role: "Full-Stack Developer",
    stack:
      "Go, Next.js, React.js, TypeScript, PostgreSQL, Redis, Wagmi, Viem, WalletConnect, Zustand",
  },
  {
    id: 3,
    name: "Pakistan Energy Crisis Scenario Simulator",
    description:
      "Scenario-planning dashboard for energy supply disruption analysis, inventory modeling, pipeline risk, pricing impact, conservation triggers, report generation, and Excel workflows.",
    liveUrl: "",
    role: "Frontend Developer",
    stack:
      "Next.js, React.js, TypeScript, Tailwind CSS, Zustand, Excel Export, Data Visualization",
  },
  {
    id: 4,
    name: "Smart City Geospatial Intelligence Dashboard",
    description:
      "Map-based smart city monitoring interface for camera intelligence, incidents, scenarios, filters, map controls, and war-gaming style geospatial workflows.",
    liveUrl: "",
    role: "Frontend Developer",
    stack:
      "Next.js, React.js, TypeScript, Tailwind CSS, Leaflet, React Leaflet, Zustand",
  },
  {
    id: 5,
    name: "AI Security Reporting Assistant",
    description:
      "AI-powered security assistant with chat-based vulnerability analysis, OpenAI integration, report state management, and downloadable reporting UI components.",
    liveUrl: "",
    role: "Frontend Developer",
    stack: "Next.js, React.js, TypeScript, Tailwind CSS, OpenAI API",
  },
  {
    id: 6,
    name: "Restaurant Ordering Platform",
    description:
      "Customer-facing restaurant discovery, catalog, store detail, cart, checkout, payment, address, account, and partner super-app embedding flows.",
    liveUrl: "https://www.gett.co/",
    role: "Frontend Developer",
    stack:
      "React.js, TypeScript, Vite, TanStack Router, TanStack Query, Panda CSS, Capacitor, REST APIs, Marketfront SDK",
  },
  {
    id: 7,
    name: "Electronic Money Institution Platform",
    description:
      "Financial web platform features for performance, authentication, compliance management, and client-specific API integrations.",
    liveUrl: "",
    role: "Frontend Developer",
    stack: "Vue.js, Tailwind CSS, FormKit",
  },
  {
    id: 8,
    name: "BYOJS Storage Contribution",
    description:
      "Open-source contribution adding bulk getMany, setMany, and removeMany APIs for a JavaScript key-value storage library covering browser storage adapters.",
    liveUrl: "https://github.com/BYOJS/storage/pull/6",
    role: "Open Source Contributor",
    stack: "JavaScript, Browser Storage APIs, IndexedDB, Open Source",
  },
];

export const educations = [
  {
    id: 1,
    title: "Bachelors in Computer Science",
    duration: "2019 - 2023",
    institution: "University of Engineering and Technology, Lahore",
  },
];

export const ContactMe = {
  description:
    "If you have any questions or concerns, please don't hesitate to contact me. I am open to any work opportunities that align with my skills and interests.",
};
